import { useRouter } from "router2";

export const isWebPath = (pathname?: string): boolean => {
  if (typeof pathname === "string") {
    return pathname.startsWith("/web");
  }
  if (typeof window !== "undefined") {
    return window.location.pathname.startsWith("/web");
  }
  return false;
};

export const toWebPath = (path: string): string => {
  if (path.startsWith("/web")) {
    return path;
  }
  return `/web${path === "/" ? "" : path}`;
};

export const useIsWeb = (): boolean => {
  const { pathname } = useRouter();
  return isWebPath(pathname);
};
